/**
 * Mappa unica dei colori delle prenotazioni condivisa da tutta l'app
 * (calendario admin, widget "Prossimi 7 giorni", elenco prenotazioni).
 * Modificare qui = cambia ovunque, così la leggenda resta sempre coerente.
 */

// Pallino colorato / bordi laterali
export const STATUS_DOT = {
  confirmed: "bg-emerald-500",
  completed: "bg-violet-500",
  pending: "bg-amber-400",
  checked_in: "bg-amber-500",
  rejected: "bg-rose-300",
  cancelled: "bg-slate-300",
  frozen: "bg-sky-400",
};

// Sfondi tenui per le pillole/cell body (usati nel widget "Prossimi 7 giorni")
export const STATUS_BG = {
  confirmed: "bg-emerald-50 border-emerald-300",
  completed: "bg-violet-50 border-violet-300",
  pending: "bg-amber-50 border-amber-300",
  checked_in: "bg-amber-100 border-amber-400",
  rejected: "bg-rose-50 border-rose-200",
  cancelled: "bg-slate-50 border-slate-200",
  frozen: "bg-sky-50 border-sky-300",
};

// Etichette leggibili
export const STATUS_LABEL = {
  confirmed: "Confermata",
  completed: "Pagata",
  pending: "In attesa",
  checked_in: "Check-in fatto",
  rejected: "Rifiutata",
  cancelled: "Annullata",
  frozen: "Congelata",
};

/**
 * Prende una prenotazione e restituisce la classe di sfondo tenue.
 * Default: emerald-50 (confermata) per sicurezza se lo status manca.
 */
export function bgForBooking(b) {
  const st = (b?.status || "").toLowerCase();
  return STATUS_BG[st] || STATUS_BG.confirmed;
}
